import { getSterilizationReports, getSterilizationReportsCount } from '../utils/requests/usersAPI'
import {
  getRegisteredDevicesChartData,
  getRegisteredDevicesTableData,
  getSoldDevicesCountries,
  getRegisteredDevicesCountries,
  getConnectedDevicesCountries,
  downloadRegisteredDevices,
  refreshRegisteredDevices,
  getRegisteredUsersChartData,
  getRegisteredUsersTableData,
  getRegisteredUsersCountries,
  downloadRegisteredUsers,
  getGeographicalConnectionSummaryData,
  downloadGeographicalConnectionReports,
  getSoldUnitsConnectionData,
  getFirmwareDownloadStatisticsData,
  // getFirmwareDownloadTableData,
  getFirmwareDownloadCountries,
  downloadFirmwareDownload,
  getRemoteAccessConnectionRawData,
  getRemoteAccessConnectionStatisticsData,
  downloadRemoteAccessConnectionReports,
  getSoftwareVersionRawData,
  getSoftwareVersionStatisticData,
  downloadSoftwareVersionReports,
  getSoftwareVersionReportFilterOptions,
  downloadRawSoldUnitsConnectionReports,
  downloadStatisticSoldUnitsConnectionReports,
} from '../utils/requests/reportsAPI'
import { getAnalyticsFaultsList } from '../utils/requests/cyclesAPI'

export const LOAD_STERILIZATION_REPORTS = 'LOAD_STERILIZATION_REPORTS'
export const LOAD_STERILIZATION_REPORTS_PENDING = 'LOAD_STERILIZATION_REPORTS_PENDING'
export const LOAD_STERILIZATION_REPORTS_FULFILLED = 'LOAD_STERILIZATION_REPORTS_FULFILLED'
export const LOAD_STERILIZATION_REPORTS_REJECTED = 'LOAD_STERILIZATION_REPORTS_REJECTED'

export const LOAD_STERILIZATION_REPORTS_COUNT = 'LOAD_STERILIZATION_REPORTS_COUNT'
export const LOAD_STERILIZATION_REPORTS_COUNT_PENDING = 'LOAD_STERILIZATION_REPORTS_COUNT_PENDING'
export const LOAD_STERILIZATION_REPORTS_COUNT_FULFILLED = 'LOAD_STERILIZATION_REPORTS_COUNT_FULFILLED'
export const LOAD_STERILIZATION_REPORTS_COUNT_REJECTED = 'LOAD_STERILIZATION_REPORTS_COUNT_REJECTED'

export const LOAD_ANALYTICS_FAULTS_LIST_DATA = 'LOAD_ANALYTICS_FAULTS_LIST_DATA'
export const LOAD_ANALYTICS_FAULTS_LIST_DATA_PENDING = 'LOAD_ANALYTICS_FAULTS_LIST_DATA_PENDING'
export const LOAD_ANALYTICS_FAULTS_LIST_DATA_FULFILLED = 'LOAD_ANALYTICS_FAULTS_LIST_DATA_FULFILLED'
export const LOAD_ANALYTICS_FAULTS_LIST_DATA_REJECTED = 'LOAD_ANALYTICS_FAULTS_LIST_DATA_REJECTED'

export const LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA = 'LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA'
export const LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_PENDING = 'LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_PENDING'
export const LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_FULFILLED = 'LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_FULFILLED'
export const LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_REJECTED = 'LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA_REJECTED'

export const LOAD_REGISTERED_DEVICES_CHART_DATA = 'LOAD_REGISTERED_DEVICES_CHART_DATA'
export const LOAD_REGISTERED_DEVICES_CHART_DATA_PENDING = 'LOAD_REGISTERED_DEVICES_CHART_DATA_PENDING'
export const LOAD_REGISTERED_DEVICES_CHART_DATA_FULFILLED = 'LOAD_REGISTERED_DEVICES_CHART_DATA_FULFILLED'
export const LOAD_REGISTERED_DEVICES_CHART_DATA_REJECTED = 'LOAD_REGISTERED_DEVICES_CHART_DATA_REJECTED'

export const LOAD_REGISTERED_USERS_CHART_DATA = 'LOAD_REGISTERED_USERS_CHART_DATA'
export const LOAD_REGISTERED_USERS_CHART_DATA_PENDING = 'LOAD_REGISTERED_USERS_CHART_DATA_PENDING'
export const LOAD_REGISTERED_USERS_CHART_DATA_FULFILLED = 'LOAD_REGISTERED_USERS_CHART_DATA_FULFILLED'
export const LOAD_REGISTERED_USERS_CHART_DATA_REJECTED = 'LOAD_REGISTERED_USERS_CHART_DATA_REJECTED'

export const LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA = 'LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA'
export const LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_PENDING = 'LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_PENDING'
export const LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_FULFILLED = 'LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_FULFILLED'
export const LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_REJECTED = 'LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA_REJECTED'

export const LOAD_REGISTERED_DEVICES_TABLE_DATA = 'LOAD_REGISTERED_DEVICES_TABLE_DATA'
export const LOAD_REGISTERED_DEVICES_TABLE_DATA_PENDING = 'LOAD_REGISTERED_DEVICES_TABLE_DATA_PENDING'
export const LOAD_REGISTERED_DEVICES_TABLE_DATA_FULFILLED = 'LOAD_REGISTERED_DEVICES_TABLE_DATA_FULFILLED'
export const LOAD_REGISTERED_DEVICES_TABLE_DATA_REJECTED = 'LOAD_REGISTERED_DEVICES_TABLE_DATA_REJECTED'

export const LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA = 'LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA'
export const LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_PENDING = 'LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_PENDING'
export const LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_FULFILLED = 'LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_FULFILLED'
export const LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_REJECTED = 'LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA_REJECTED'

export const LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA = 'LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA'
export const LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING = 'LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING'
export const LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED = 'LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED'
export const LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED = 'LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED'

export const LOAD_REGISTERED_USERS_TABLE_DATA = 'LOAD_REGISTERED_USERS_TABLE_DATA'
export const LOAD_REGISTERED_USERS_TABLE_DATA_PENDING = 'LOAD_REGISTERED_USERS_TABLE_DATA_PENDING'
export const LOAD_REGISTERED_USERS_TABLE_DATA_FULFILLED = 'LOAD_REGISTERED_USERS_TABLE_DATA_FULFILLED'
export const LOAD_REGISTERED_USERS_TABLE_DATA_REJECTED = 'LOAD_REGISTERED_USERS_TABLE_DATA_REJECTED'

// export const LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA = 'LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA'
// export const LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA_PENDING = 'LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA_PENDING'
// export const LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA_FULFILLED = 'LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA_FULFILLED'
// export const LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA_REJECTED = 'LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA_REJECTED'

export const LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA = 'LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA'
export const LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_PENDING = 'LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_PENDING'
export const LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_FULFILLED = 'LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_FULFILLED'
export const LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_REJECTED = 'LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA_REJECTED'

export const LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA = 'LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA'
export const LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA_PENDING = 'LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA_PENDING'
export const LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA_FULFILLED = 'LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA_FULFILLED'
export const LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA_REJECTED = 'LOAD_NEW_GEOGRAPHICAL_CONNECTION_TABLE_DATA_REJECTED'

// export const LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA = 'LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA'
// export const LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA_PENDING = 'LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA_PENDING'
// export const LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA_FULFILLED = 'LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA_FULFILLED'
// export const LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA_REJECTED = 'LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA_REJECTED'

export const LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA = 'LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA'
export const LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING = 'LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_PENDING'
export const LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED = 'LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_FULFILLED'
export const LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED = 'LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA_REJECTED'

export const LOAD_SOLD_DEVICES_COUNTRIES = 'LOAD_SOLD_DEVICES_COUNTRIES'
export const LOAD_SOLD_DEVICES_COUNTRIES_PENDING = 'LOAD_SOLD_DEVICES_COUNTRIES_PENDING'
export const LOAD_SOLD_DEVICES_COUNTRIES_FULFILLED = 'LOAD_SOLD_DEVICES_COUNTRIES_FULFILLED'
export const LOAD_SOLD_DEVICES_COUNTRIES_REJECTED = 'LOAD_SOLD_DEVICES_COUNTRIES_REJECTED'

export const LOAD_REGISTERED_DEVICES_COUNTRIES = 'LOAD_REGISTERED_DEVICES_COUNTRIES'
export const LOAD_REGISTERED_DEVICES_COUNTRIES_PENDING = 'LOAD_REGISTERED_DEVICES_COUNTRIES_PENDING'
export const LOAD_REGISTERED_DEVICES_COUNTRIES_FULFILLED = 'LOAD_REGISTERED_DEVICES_COUNTRIES_FULFILLED'
export const LOAD_REGISTERED_DEVICES_COUNTRIES_REJECTED = 'LOAD_REGISTERED_DEVICES_COUNTRIES_REJECTED'

export const LOAD_CONNECTED_DEVICES_COUNTRIES = 'LOAD_CONNECTED_DEVICES_COUNTRIES'
export const LOAD_CONNECTED_DEVICES_COUNTRIES_PENDING = 'LOAD_CONNECTED_DEVICES_COUNTRIES_PENDING'
export const LOAD_CONNECTED_DEVICES_COUNTRIES_FULFILLED = 'LOAD_CONNECTED_DEVICES_COUNTRIES_FULFILLED'
export const LOAD_CONNECTED_DEVICES_COUNTRIES_REJECTED = 'LOAD_CONNECTED_DEVICES_COUNTRIES_REJECTED'

export const LOAD_REGISTERED_USERS_COUNTRIES = 'LOAD_REGISTERED_USERS_COUNTRIES'
export const LOAD_REGISTERED_USERS_COUNTRIES_PENDING = 'LOAD_REGISTERED_USERS_COUNTRIES_PENDING'
export const LOAD_REGISTERED_USERS_COUNTRIES_FULFILLED = 'LOAD_REGISTERED_USERS_COUNTRIES_FULFILLED'
export const LOAD_REGISTERED_USERS_COUNTRIES_REJECTED = 'LOAD_REGISTERED_USERS_COUNTRIES_REJECTED'

export const LOAD_FIRMWARE_DOWNLOAD_COUNTRIES = 'LOAD_FIRMWARE_DOWNLOAD_COUNTRIES'
export const LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_PENDING = 'LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_PENDING'
export const LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_FULFILLED = 'LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_FULFILLED'
export const LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_REJECTED = 'LOAD_FIRMWARE_DOWNLOAD_COUNTRIES_REJECTED'

export const DOWNLOAD_REGISTERED_DEVICES = 'DOWNLOAD_REGISTERED_DEVICES'
export const DOWNLOAD_REGISTERED_DEVICES_PENDING = 'DOWNLOAD_REGISTERED_DEVICES_PENDING'
export const DOWNLOAD_REGISTERED_DEVICES_FULFILLED = 'DOWNLOAD_REGISTERED_DEVICES_FULFILLED'
export const DOWNLOAD_REGISTERED_DEVICES_REJECTED = 'DOWNLOAD_REGISTERED_DEVICES_REJECTED'

export const DOWNLOAD_GEOGRAPHICAL_CONNECTION = 'DOWNLOAD_GEOGRAPHICAL_CONNECTION'
export const DOWNLOAD_GEOGRAPHICAL_CONNECTION_PENDING = 'DOWNLOAD_GEOGRAPHICAL_CONNECTION_PENDING'
export const DOWNLOAD_GEOGRAPHICAL_CONNECTION_FULFILLED = 'DOWNLOAD_GEOGRAPHICAL_CONNECTION_FULFILLED'
export const DOWNLOAD_GEOGRAPHICAL_CONNECTION_REJECTED = 'DOWNLOAD_GEOGRAPHICAL_CONNECTION_REJECTED'

export const DOWNLOAD_RAW_SOLD_UNITS_CONNECTION = 'DOWNLOAD_RAW_SOLD_UNITS_CONNECTION'
export const DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_PENDING = 'DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_PENDING'
export const DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_FULFILLED = 'DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_FULFILLED'
export const DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_REJECTED = 'DOWNLOAD_RAW_SOLD_UNITS_CONNECTION_REJECTED'

export const DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION = 'DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION'
export const DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_PENDING = 'DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_PENDING'
export const DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_FULFILLED = 'DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_FULFILLED'
export const DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_REJECTED = 'DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION_REJECTED'

export const DOWNLOAD_REGISTERED_USERS = 'DOWNLOAD_REGISTERED_USERS'
export const DOWNLOAD_REGISTERED_USERS_PENDING = 'DOWNLOAD_REGISTERED_USERS_PENDING'
export const DOWNLOAD_REGISTERED_USERS_FULFILLED = 'DOWNLOAD_REGISTERED_USERS_FULFILLED'
export const DOWNLOAD_REGISTERED_USERS_REJECTED = 'DOWNLOAD_REGISTERED_USERS_REJECTED'

export const DOWNLOAD_FIRMWARE_DOWNLOAD = 'DOWNLOAD_FIRMWARE_DOWNLOAD'
export const DOWNLOAD_FIRMWARE_DOWNLOAD_PENDING = 'DOWNLOAD_FIRMWARE_DOWNLOAD_PENDING'
export const DOWNLOAD_FIRMWARE_DOWNLOAD_FULFILLED = 'DOWNLOAD_FIRMWARE_DOWNLOAD_FULFILLED'
export const DOWNLOAD_FIRMWARE_DOWNLOAD_REJECTED = 'DOWNLOAD_FIRMWARE_DOWNLOAD_REJECTED'

export const REFRESH_REGISTERED_DEVICES = 'REFRESH_REGISTERED_DEVICES'
export const REFRESH_REGISTERED_DEVICES_PENDING = 'REFRESH_REGISTERED_DEVICES_PENDING'
export const REFRESH_REGISTERED_DEVICES_FULFILLED = 'REFRESH_REGISTERED_DEVICES_FULFILLED'
export const REFRESH_REGISTERED_DEVICES_REJECTED = 'REFRESH_REGISTERED_DEVICES_REJECTED'

export const LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA = 'LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA'
export const LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_PENDING = 'LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_PENDING'
export const LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_FULFILLED = 'LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_FULFILLED'
export const LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_REJECTED = 'LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA_REJECTED'

export const LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA = 'LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA'
export const LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_PENDING = 'LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_PENDING'
export const LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_FULFILLED = 'LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_FULFILLED'
export const LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_REJECTED = 'LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA_REJECTED'

export const DOWNLOAD_REMOTE_ACCESS_CONNECTION = 'DOWNLOAD_REMOTE_ACCESS_CONNECTION'
export const DOWNLOAD_REMOTE_ACCESS_CONNECTION_PENDING = 'DOWNLOAD_REMOTE_ACCESS_CONNECTION_PENDING'
export const DOWNLOAD_REMOTE_ACCESS_CONNECTION_FULFILLED = 'DOWNLOAD_REMOTE_ACCESS_CONNECTION_FULFILLED'
export const DOWNLOAD_REMOTE_ACCESS_CONNECTION_REJECTED = 'DOWNLOAD_REMOTE_ACCESS_CONNECTION_REJECTED'

export const LOAD_SOFTWARE_VERSION_RAW_DATA = 'LOAD_SOFTWARE_VERSION_RAW_DATA'
export const LOAD_SOFTWARE_VERSION_RAW_DATA_PENDING = 'LOAD_SOFTWARE_VERSION_RAW_DATA_PENDING'
export const LOAD_SOFTWARE_VERSION_RAW_DATA_FULFILLED = 'LOAD_SOFTWARE_VERSION_RAW_DATA_FULFILLED'
export const LOAD_SOFTWARE_VERSION_RAW_DATA_REJECTED = 'LOAD_SOFTWARE_VERSION_RAW_DATA_REJECTED'

export const LOAD_SOFTWARE_VERSION_STATISTICS_DATA = 'LOAD_SOFTWARE_VERSION_STATISTICS_DATA'
export const LOAD_SOFTWARE_VERSION_STATISTICS_DATA_PENDING = 'LOAD_SOFTWARE_VERSION_STATISTICS_DATA_PENDING'
export const LOAD_SOFTWARE_VERSION_STATISTICS_DATA_FULFILLED = 'LOAD_SOFTWARE_VERSION_STATISTICS_DATA_FULFILLED'
export const LOAD_SOFTWARE_VERSION_STATISTICS_DATA_REJECTED = 'LOAD_SOFTWARE_VERSION_STATISTICS_DATA_REJECTED'

export const DOWNLOAD_SOFTWARE_VERSION_REPORTS = 'DOWNLOAD_SOFTWARE_VERSION_REPORTS'
export const DOWNLOAD_SOFTWARE_VERSION_REPORTS_PENDING = 'DOWNLOAD_SOFTWARE_VERSION_REPORTS_PENDING'
export const DOWNLOAD_SOFTWARE_VERSION_REPORTS_FULFILLED = 'DOWNLOAD_SOFTWARE_VERSION_REPORTS_FULFILLED'
export const DOWNLOAD_SOFTWARE_VERSION_REPORTS_REJECTED = 'DOWNLOAD_SOFTWARE_VERSION_REPORTS_REJECTED'

export const LOAD_SOFTWARE_VERSION_FILTER_OPTIONS = 'LOAD_SOFTWARE_VERSION_FILTER_OPTIONS'
export const LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_PENDING = 'LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_PENDING'
export const LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_FULFILLED = 'LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_FULFILLED'
export const LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_REJECTED = 'LOAD_SOFTWARE_VERSION_FILTER_OPTIONS_REJECTED'

export const REPORTS_CLEAR_MESSAGES = 'REPORTS_CLEAR_MESSAGES'

export function loadSterilizationReports(cognitoSub, queryParams) {
  return {
    type: LOAD_STERILIZATION_REPORTS,
    payload: getSterilizationReports(cognitoSub, queryParams),
  }
}

export function loadSterilizationReportsCount(cognitoSub, queryParams) {
  return {
    type: LOAD_STERILIZATION_REPORTS_COUNT,
    payload: getSterilizationReportsCount(cognitoSub, queryParams),
    meta: { queryParams },
  }
}

// ------------------------REGISTERED DEVICES------------------------
export function loadRegisteredDevicesChartData(queryParams) {
  return {
    type: LOAD_REGISTERED_DEVICES_CHART_DATA,
    payload: getRegisteredDevicesChartData(queryParams),
    meta: { queryParams },
  }
}

export function loadRegisteredDevicesTableData(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_REGISTERED_DEVICES_TABLE_DATA : LOAD_REGISTERED_DEVICES_TABLE_DATA,
    payload: getRegisteredDevicesTableData(queryParams),
  }
}

export function loadSoldDevicesCountries() {
  return {
    type: LOAD_SOLD_DEVICES_COUNTRIES,
    payload: getSoldDevicesCountries(),
  }
}

export function loadRegisteredDevicesCountries() {
  return {
    type: LOAD_REGISTERED_DEVICES_COUNTRIES,
    payload: getRegisteredDevicesCountries(),
  }
}

export function loadConnectedDevicesCountries() {
  return {
    type: LOAD_CONNECTED_DEVICES_COUNTRIES,
    payload: getConnectedDevicesCountries(),
  }
}

export function refreshRegisteredDevicesData() {
  return {
    type: REFRESH_REGISTERED_DEVICES,
    payload: refreshRegisteredDevices(),
  }
}

export function downloadRegisteredDevicesData(queryParams) {
  return {
    type: DOWNLOAD_REGISTERED_DEVICES,
    payload: downloadRegisteredDevices(queryParams),
    meta: { queryParams },
  }
}

// ------------------------GEOGRAPHICAL CONNECTION REPORTS------------------------
export function loadGeographicalConnectionSummaryData(queryParams) {
  return {
    type: LOAD_GEOGRAPHICAL_CONNECTION_SUMMARY_DATA,
    payload: getGeographicalConnectionSummaryData(queryParams),
    meta: { queryParams },
  }
}

export function downloadGeographicalConnectionData(queryParams) {
  return {
    type: DOWNLOAD_GEOGRAPHICAL_CONNECTION,
    payload: downloadGeographicalConnectionReports(queryParams),
    meta: { queryParams },
  }
}

// ------------------------SOLD UNITS CONNECTION REPORTS------------------------
export function loadSoldUnitsConnectionData(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_SOLD_UNITS_CONNECTION_TABLE_DATA : LOAD_SOLD_UNITS_CONNECTION_TABLE_DATA,
    payload: getSoldUnitsConnectionData(queryParams),
  }
}

export function downloadRawSoldUnitsConnectionData(queryParams) {
  return {
    type: DOWNLOAD_RAW_SOLD_UNITS_CONNECTION,
    payload: downloadRawSoldUnitsConnectionReports(queryParams),
    meta: { queryParams },
  }
}

export function downloadStatisticSoldUnitsConnectionData(queryParams) {
  return {
    type: DOWNLOAD_STATISTIC_SOLD_UNITS_CONNECTION,
    payload: downloadStatisticSoldUnitsConnectionReports(queryParams),
    meta: { queryParams },
  }
}

// ------------------------Analytics Reports------------------------
export function loadAnalyticsFaultsList(queryParams, refetch = false) {
  return {
    type: refetch ? LOAD_NEW_ANALYTICS_FAULTS_LIST_DATA : LOAD_ANALYTICS_FAULTS_LIST_DATA,
    payload: getAnalyticsFaultsList(queryParams),
  }
}

// ------------------------REGISTERED USERS------------------------
export function loadRegisteredUsersChartData(queryParams) {
  return {
    type: LOAD_REGISTERED_USERS_CHART_DATA,
    payload: getRegisteredUsersChartData(queryParams),
    meta: { queryParams },
  }
}

export function loadRegisteredUsersTableData(queryParams) {
  return {
    type: LOAD_REGISTERED_USERS_TABLE_DATA,
    payload: getRegisteredUsersTableData(queryParams),
    meta: { queryParams },
  }
}

export function loadRegisteredUsersCountries() {
  return {
    type: LOAD_REGISTERED_USERS_COUNTRIES,
    payload: getRegisteredUsersCountries(),
  }
}

export function downloadRegisteredUsersData(queryParams) {
  return {
    type: DOWNLOAD_REGISTERED_USERS,
    payload: downloadRegisteredUsers(queryParams),
    meta: { queryParams },
  }
}

// ------------------------FIRMWARE DOWNLOADS------------------------
export function loadFirmwareDownloadStatisticsData(queryParams) {
  return {
    type: LOAD_FIRMWARE_DOWNLOAD_STATISTICS_DATA,
    payload: getFirmwareDownloadStatisticsData(queryParams),
    meta: { queryParams },
  }
}

// export function loadFirmwareDownloadTableData(queryParams, refetch = false) {
//   return {
//     type: refetch ? LOAD_NEW_FIRMWARE_DOWNLOAD_TABLE_DATA : LOAD_FIRMWARE_DOWNLOAD_TABLE_DATA,
//     payload: getFirmwareDownloadTableData(queryParams),
//     meta: { queryParams },
//   }
// }

export function loadFirmwareDownloadCountries() {
  return {
    type: LOAD_FIRMWARE_DOWNLOAD_COUNTRIES,
    payload: getFirmwareDownloadCountries(),
  }
}

export function downloadFirmwareDownloadData(queryParams) {
  return {
    type: DOWNLOAD_FIRMWARE_DOWNLOAD,
    payload: downloadFirmwareDownload(queryParams),
    meta: { queryParams },
  }
}

export function clearReportsMessages() {
  return {
    type: REPORTS_CLEAR_MESSAGES,
  }
}

// ------------------------REMOTE ACCESS CONNECTION REPORTS------------------------
export function loadRemoteAccessConnectionRawData(queryParams) {
  return {
    type: LOAD_REMOTE_ACCESS_CONNECTION_RAW_DATA,
    payload: getRemoteAccessConnectionRawData(queryParams),
    meta: { queryParams },
  }
}

export function loadRemoteAccessConnectionStatisticsData(queryParams) {
  return {
    type: LOAD_REMOTE_ACCESS_CONNECTION_STATISTICS_DATA,
    payload: getRemoteAccessConnectionStatisticsData(queryParams),
    meta: { queryParams },
  }
}

export function downloadRemoteAccessConnectionData(queryParams) {
  return {
    type: DOWNLOAD_REMOTE_ACCESS_CONNECTION,
    payload: downloadRemoteAccessConnectionReports(queryParams),
    meta: { queryParams },
  }
}

// ------------------------SOFTWARE VERSIONS REPORTS------------------------
export function loadSoftwareVersionRawData(queryParams) {
  return {
    type: LOAD_SOFTWARE_VERSION_RAW_DATA,
    payload: getSoftwareVersionRawData(queryParams),
    meta: { queryParams },
  }
}

export function loadSoftwareVersionStatisticsData(queryParams) {
  return {
    type: LOAD_SOFTWARE_VERSION_STATISTICS_DATA,
    payload: getSoftwareVersionStatisticData(queryParams),
    meta: { queryParams },
  }
}

export function downloadSoftwareVersionReportsCSV(queryParams) {
  return {
    type: DOWNLOAD_SOFTWARE_VERSION_REPORTS,
    payload: downloadSoftwareVersionReports(queryParams),
    meta: { queryParams },
  }
}

export function loadSoftwareVersionReportsFilterOptions() {
  return {
    type: LOAD_SOFTWARE_VERSION_FILTER_OPTIONS,
    payload: getSoftwareVersionReportFilterOptions(),
  }
}

